export const downKeys = ['Down', 'ArrowDown'];
export const upKeys = ['Up', 'ArrowUp'];
export const forwardArrowKeys = [...downKeys, 'Right', 'ArrowRight'];
export const backwardArrowKeys = [...upKeys, 'Left', 'ArrowLeft'];
export const homeEndKeys = ['Home', 'End'];
export const pageUpDownKeys = ['PageUp', 'PageDown'];
export const moveKeys = [...forwardArrowKeys, ...backwardArrowKeys, ...homeEndKeys, ...pageUpDownKeys];
export const modifierKeys = ['Meta', 'Shift', 'CapsLock', 'Alt', 'Control'];
export const nonCharacterKeys = [...moveKeys, ...modifierKeys, 'Escape'];